<kal-form-field>
    <kal-input *ngIf="disabled; else InputAutocompleteTemplate"
               [formControl]="control"
               [label]="label">
    </kal-input>
    <ng-template #InputAutocompleteTemplate>
        <kal-input
                   [formControl]="control"
                   [kalAutocompleteLoading]="loading"
                   [kalAutocomplete]="displayedList"
                   [label]="label"
                   [required]="required"
                   (kalAutocompleteClosed)="clearSupplier()"
                   (kalAutocompleteSelected)="pickSupplier($event)"
                   icon="keyboard_arrow_down"
                   placeholder="Fournisseur, code fournisseur">
        </kal-input>
    </ng-template>
    <ng-container *ngIf="withReplenishementOption">
        <kal-checkbox [formControl]="suppliersWithPendingReplenishementArticlesControl"
                      label="Ne voir que les fournisseurs avec des articles en réapprovisionnement en attente de commande">

        </kal-checkbox>
    </ng-container>
</kal-form-field>
